// extracted by mini-css-extract-plugin
export default {"subTitle":"CategoriesScreen_subTitle__KbM+q","buttonContainer":"CategoriesScreen_buttonContainer__5KYJs","buttonGap":"CategoriesScreen_buttonGap__OMrMn"};